import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { camelCase } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Charts, Loader } from "shared/components";
import "./SingleChart.scss";

interface SingleChartProps {
  individualMetricData?: any;
  individualMetricsCategories?: any;
  individualMetrics?: any;
  selectedMetric?: any;
  filterIndividualMetrics?: any;
  color: string[];
  colorText: string;
  title?: string;
  loading?: boolean;
}

const disabledChart = (subtitle: string, colorText: string, title?: string) => {
  return (
    <>
      <p className="chart-title" style={{ color: colorText }}>
        {title}
      </p>
      <div className="latam-banner" style={{ height: "300px" }}>
        <div className="box">
          <FontAwesomeIcon icon={faExclamationTriangle} color="#E4BC5C" />
          <span>{subtitle}</span>
        </div>
      </div>
    </>
  );
};

const formatByMetric = (metric: string) => {
  switch (metric) {
    case "performanceIndex":
    case "developmentIndex":
    case "engagementIndex":
    case "followersIndex":
    case "likesMedianInstagram":
    case "commentsMedianInstagram":
      return (value: number) => `${value && value.toFixed(1)}`;
    case "performanceSpotify":
    case "followersCntSpotify":
    case "popularitySpotify":
    case "viewsCntYoutube":
    case "subscribersCntYoutube":
    case "followersCntInstagram":
      return (value: number) => `${Math.floor(value)}`;
  }
};

const SingleChart: React.FC<SingleChartProps> = (props) => {
  const {
    individualMetricData,
    individualMetricsCategories,
    individualMetrics,
    selectedMetric,
    filterIndividualMetrics,
    color,
    title,
    colorText,
    loading,
  } = props;
  const { t } = useTranslation("radar");
  const [enableChart, setEnableChart] = useState(false);

  const getMinMax = () => {
    const delimeter = individualMetrics?.dataDelimiters?.find((del: any) => {
      return (
        camelCase(del.metric) === selectedMetric &&
        del.comparisonWindow === `${filterIndividualMetrics}`
      );
    });
    const { min, max } = delimeter || {};
    return { min, max };
  };

  const { min, max } = getMinMax();
  useEffect(() => {
    setEnableChart(
      individualMetricData.length > 0 &&
        individualMetricData[0].data.some(
          (opt: any) => opt !== null && opt !== 0
        )
    );
  }, [individualMetricData]);

  // if (loading) return <Loader.Simple spinning />;
  if (!enableChart && !loading)
    return disabledChart(
      t("pages.ArtistProfile.noHaveInformation"),
      colorText,
      title
    );

  return (
    <Loader.Locale spinning={loading}>
      <Charts.AreaChart
        height={450}
        titulo={title}
        markerSize={6}
        color={color}
        strokeWidth={1}
        textColor={colorText}
        colorTitle={colorText}
        series={individualMetricData}
        categories={individualMetricsCategories}
        showAnnotationMonths
        xAxisFormatter={formatByMetric(selectedMetric)}
        xaxisLabelFormat="MM/yy"
        xaxisType="datetime"
        tooltipTitleFormat
        min={min}
        max={max}
        tooltip={{
          label: t("pages.ArtistProfile.releasesLabel"),
          points:
            individualMetrics?.markers.map((serie: any) => ({
              text: serie.text,
              x: new Date(moment(serie.x).toDate()).getTime(),
              y: serie.y[selectedMetric],
            })) || [],
        }}
      />
    </Loader.Locale>
  );
};

export default SingleChart;
